import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabaseService from '../services/supabaseService';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { toast } from 'react-hot-toast';

const VerifyEmailScreen = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // جلب البريد الإلكتروني من التخزين المحلي
    const storedEmail = localStorage.getItem('verification_email');
    
    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      toast.error('لم يتم العثور على بريد إلكتروني، يرجى البدء من جديد');
      navigate('/auth');
    }
  }, [navigate]);

  const handleResend = async () => {
    if (!email) return;
    
    setLoading(true);
    try {
      // إعادة إرسال رمز التحقق
      const { error } = await supabaseService.client.auth.resend({
        type: 'signup',
        email: email,
      });
      
      if (error) throw error;
      
      toast.success('تم إرسال رمز جديد إلى بريدك الإلكتروني');
    } catch (error) {
      console.error('Resend error:', error);
      toast.error('فشل إعادة إرسال الرمز');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code || code.length !== 8) {
      return toast.error('يرجى إدخال الرمز المكون من 8 أرقام');
    }

    if (!email) {
      return toast.error('خطأ: البريد الإلكتروني مفقود');
    }

    setLoading(true);
    try {
      console.log('🔍 Verifying email with code...');
      
      // التحقق من رمز البريد الإلكتروني
      const { data, error } = await supabaseService.verifyOtp(email, code, 'email');

      if (error) throw error;

      console.log('✅ Email verified successfully:', data);
      
      toast.success('تم التحقق من البريد الإلكتروني بنجاح');
      
      // حذف البريد المحفوظ
      localStorage.removeItem('verification_email');
      
      // الانتقال لصفحة التسجيل
      setTimeout(() => {
        navigate('/register');
      }, 500);
      
    } catch (error) {
      console.error('Verification Error:', error);
      toast.error(error.message || 'الرمز غير صحيح أو منتهي الصلاحية');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <motion.div
        className="w-full max-w-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* زر العودة */}
        <button
          onClick={() => {
            localStorage.removeItem('verification_email');
            navigate('/auth');
          }}
          className="mb-6 flex items-center text-gray-500 hover:text-gray-900 transition-colors text-sm font-medium"
        >
          <FiArrowLeft className="ml-2" />
          العودة
        </button>

        {/* العنوان والوصف */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 tracking-tight">تأكيد البريد الإلكتروني</h2>
          <p className="text-gray-500 mt-2 text-sm">
            أدخل الرمز المكون من 8 أرقام المرسل إلى بريدك الإلكتروني
          </p>
          <p className="text-gray-400 text-xs mt-2 break-all font-medium">
            {email}
          </p>
        </div>
        
        {/* النموذج */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex justify-center">
            <div className="relative w-full">
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="00000000"
                className="w-full text-center text-3xl font-bold tracking-[0.35em] py-4 border-b-2 border-gray-200 focus:border-gray-900 focus:outline-none bg-transparent text-gray-900 placeholder-gray-200 transition-colors"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 8))}
                maxLength={8}
                required
                autoFocus
              />
            </div>
          </div>
          
          <button
            type="submit"
            disabled={loading || code.length !== 8}
            className="w-full bg-gray-900 text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white ml-2"></div>
                جاري التحقق...
              </div>
            ) : (
              'تحقق ومتابعة'
            )}
          </button>
        </form>

        {/* إعادة الإرسال */}
        <div className="mt-8 text-center">
          <p className="text-gray-500 text-sm mb-2">لم يصلك الرمز؟</p>
          <button
            onClick={handleResend}
            disabled={loading}
            className="text-gray-900 font-bold hover:underline disabled:opacity-50 flex items-center justify-center gap-2 mx-auto"
          >
            <FiRefreshCw className="w-4 h-4" />
            إعادة الإرسال
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default VerifyEmailScreen;